module.exports = __webpack_public_path__ + "img/dangjianBg1.5d140336.png";